import PackageGroupGalleryItemEdit from './PackageGroupGalleryItemEdit'
import PackageGroupGalleryItemList from './PackageGroupGalleryItemList'

// eslint-disable-next-line import/no-anonymous-default-export
export default {
    list: PackageGroupGalleryItemList,
    edit: PackageGroupGalleryItemEdit
}
